export default {
  'booking.totalsales': 'カウンター別の総売上',
  'booking.buy_ticket': 'チケットを購入',
  'booking.wheretogo': '行先はどこですか？',
  'booking.searchflight': 'フライト検索',
  'booking.selectflight': 'フライト選択',
  'booking.oneway': '片道',
  'booking.onewaytrip': '片道',
  'booking.roundtrip': '往復',
  'booking.multicity': '複数都市',
  'booking.bestguarantee': 'オンライン最安値を保証',
  'booking.getdeals': 'スペシャルオファー',
  'booking.signupnow': '今すぐ登録',
  'booking.from': '出発地',
  'booking.to': '目的地',
  'booking.guest': '利用者',
  'booking.city': '都市',
  'booking.country': '国',
  'booking.Adult': '大人',
  'booking.adult': '大人',
  'booking.Child (Age 2-12)': '子ども（2歳～12歳）',
  'booking.Infant (Age 0-2)': '幼児（２歳未満）',
  'booking.senior': 'シニア',
  'booking.senior(Over 65)': 'シニア（65歳以上）',
  'booking.students': '学生',
  'booking.students(Over 18)': '学生（18歳以上）',
  'booking.toddler': '幼児',
  'booking.toddler(Age 0-2)': '幼児（席あり）',
  'booking.guestsandcities': '利用者と都市',
  'booking.startover': 'やり直し',
  'booking.showmoredate': '他の日付を表示',
  'booking.selectdate': '日付の選択',
  'booking.date': '日付',
  'booking.changedate': '日付を変更',
  'booking.airline': '航空会社',
  'booking.departs': '出発時刻',
  'booking.arrives': '到着時刻',
  'booking.duration': '所要時間',
  'booking.travelclass': '座席クラス',
  'booking.priceperadult': '大人料金',
  'booking.priceperchild': '子ども料金',
  'booking.priceperinfant': '幼児料金',
  'booking.flightnumber': '便名',
  'booking.remainseat': '残り座席',
  'booking.cost': '料金',
  'booking.showmore': 'さらに表示',
  'booking.birthyear': '生年',
  'booking.birthmonth': '月',
  'booking.birthday': '日',
  'booking.passportno': '旅券番号',
  'booking.birthcountry': '出身国',
  'booking.passportcountry': '国籍',
  'booking.passportexpireyear': '有効期限・年',
  'booking.passportexpiremonth': '有効期限・月',
  'booking.passportexpireday': '有効期限・日',
  'booking.completeform': 'フォームを完成して続行',
  'booking.changeavatar': 'アバターを変更',
  'booking.passengerinfo': '利用者情報',
  'booking.isiranian': 'イラン国籍',
  'booking.othernationality': 'その他の国籍',
  'booking.perviousepassenger': '利用者リストから選択',
  'booking.index': 'インデックス',
  'booking.primarytraveler': '主な旅行者',
  'booking.adultinformation': '大人に関する情報',
  'booking.childinformation': '子どもに関する情報',
  'booking.infantinformation': '幼児に関する情報',
  'booking.phone': '電話番号',
  'booking.totalprice': '合計価金額',
  'booking.stopcount': 'ストップ数',
  'booking.airplanetype': '機種',
  'booking.international': '国際線',
  'booking.domestic': '国内線',
  'booking.notexist': '該当なし',
  'booking.noavailableflight': '該当するフライトがありません',
  'booking.departurecities': '出発地',
  'booking.returncities': '目的地',
  'booking.departuredate': '出発日',
  'booking.returndate': '帰国日',
  'booking.departuretime': '出発時間',
  'booking.returntime': '到着時間',
  'booking.paynow': '支払い',
  'booking.sigin': 'サインイン',
  'booking.signup': '新規登録',
  'booking.notregister': '登録されていません',
  'booking.elevatemembers': '以前メンバーでした',
  'booking.departureflightinfo': '往路に関する情報',
  'booking.returnflightinfo': '復路に関する情報',
  'booking.previouspassenger': '以前の利用者リスト',
  'booking.hi': 'こんにちは',
  'booking.travelwith': 'あなたの旅のお供',
  'booking.ticket': 'まもなくチケットが発行されます',
  'booking.successpayment': '支払いが完了しました',
  'booking.previousepassengerlist': '以前の利用者リスト',
  'booking.bookingflights': '予約便リスト',
  'booking.flightno': '便名',
  'booking.child': '子ども',
  'booking.infant': '幼児',
  'booking.male': '男性',
  'booking.female': '女性',
  'booking.departureflight': '出発便',
  'booking.returnflight': '帰国便',
  'booking.showticket': 'チケットの表示法方法',
  'booking.cancel': 'キャンセル',
  'booking.passengers': '利用者',
  'booking.price': '料金',
  'booking.returnprice': '払い戻し料金',
  'booking.cancelstatus': '状況',
  'booking.cancelreason': 'キャンセルの理由は何ですか？',
  'booking.personalproblem': '個人的事情（航空会社の規約に基づく）',
  'booking.airlineproblem': '航空会社によるキャンセル',
  'booking.flightproblem': '2時間以上の遅延または早期出発',
  'booking.back': '戻る',
  'booking.nextstep': '次に進む',
  'booking.previousstep': '前に戻る',
  'booking.cancelingrules': 'キャンセル規約',
  'booking.wait': 'お持ちください',
  'booking.flights': 'フライト',
  'booking.cancelpayment': '支払いが完了しませんでした',
  'booking.refid': '追跡コード：',
  'booking.airport': '空港',
  'booking.flighttime': '飛行時間',
  'booking.flightstopcount': 'ストップ回数',
  'booking.morning': '朝（0時～8時）',
  'booking.noon': '昼（8時～14時）',
  'booking.afternoon': '午後（14時～20時）',
  'booking.night': '夜（20時以降）',
  'booking.sort': '並び替え',
  'booking.sortbyprice': '価格順',
  'booking.sortbytime': '時間順',
  'booking.nonstop': '直行',
  'booking.onestop': '乗り継ぎ1回　',
  'booking.morethanonestop': '乗り継ぎ1回以上',
  'booking.origin': '出発地',
  'booking.destination': '目的地',
  'booking.startdate': '開始日',
  'booking.enddate': '終了日',
  'booking.search': '検索',
  'booking.filter': 'フィルター',
  'booking.agree': '同意します',
  'booking.cancelrules': 'キャンセル規則',
  'booking.flightscount': 'フライトが見つかりました',
  'booking.clearfilter': 'クリア',
  'booking.gifavatar': '動画アバターの選択',
  'booking.avatar': 'アバターの選択',
  'booking.notfound': '都市が見つかりません',
  'booking.nextyear': '翌年',
  'booking.previousyear': '前年',
  'booking.details': '詳細',
  'booking.adultprice': '大人一人当たりの料金',
  'booking.sortby': '並び替え',
  'booking.bydescendingprice': '価格',
  'booking.byascendingduration': '間隔',
  'booking.bydescendingduration': '間隔',
  'booking.byascendingprice': '価格',
  'booking.bydescendingpoint': '点',
  'booking.byascendingpoint': '点',
  'booking.bydescendingtime': '出発時間',
  'booking.byascendingarrivetime': '到着時間',
  'booking.bydescendingarrivetime': '到着時間',
  'booking.byascendingtime': '出発時間',
  'booking.justthis': 'のみ',
  'booking.searchpassenger': '利用者検索',
  'booking.edit': '編集',
  'booking.select': '選択',
  'booking.gotoday': '今日に移動',
  'booking.pricedetail': '価格の詳細',
  'booking.passengertype': 'タイプ',
  'booking.fareprice': '価格',
  'booking.tax': '税',
  'booking.allairport': '（ 全空港 ）',
  'booking.moneyunit': '（価格はすべてドル）',
  'booking.noseatresult': '席がありません',
  'booking.today': '今日　',
  'booking.terminal': 'ターミナル',
  'booking.sumprice': '総額',
  'booking.sameairport': '出発地と行き先は別の場所にしてください',
  'booking.stopin': '経由地',
  'booking.megaleapyearsale': 'うるう年メガセール',
  'booking.planasunnyd1': '今から夏の計画を立てて、',
  'booking.planasunnyd2': '29%の特別割引をお得にゲット',
  'booking.restrictionsapply': '適用される制限',
  'booking.grabaseat': '座席を獲得',
  'booking.enjoywithbestfriends': '親友と楽しんでください',
  'booking.helpafriendd1': '親友とプランを立ててください',
  'booking.helpafriendd2': 'そしてポイントを集めましょう',
  'booking.termsandconditionsapply': '適用される規約',
  'booking.bookhotels': 'ツアーを予約する',
  'booking.booktours': 'Touren buchen',
  'booking.traveldate': '旅行日',
  'booking.traveldatetime': '旅行日',
  'booking.invoice': '請求書',
  'booking.totalamount': '合計価金額',
  'booking.showreserve': 'リザーブを表示',
  'booking.takeofffaster': 'より速い対応',
  'booking.earn10kpointsd1': 'IAM TOURIST Visa Signature® Cardで',
  'booking.earn10kpointsd2': '１万ポイント獲得',
  'booking.learnmore': 'もっと見る',
  'booking.swipeforthesky': '空を飛ぼう',
  'booking.getsetforamorerewardingexperienceonthegroundandinthesky':
    '新しい I AM TOURIST Visa Signature®カードで、地上と空で素晴らしい体験をしましょう',
  'booking.firstoneonfirstoneoff': '優先搭乗、優先降機',
  'booking.inahurry':
    'お急ぎですか？キャビン前方の座席シートを選ばれるか、少額の料金で優先的なセキュリティと搭乗をご利用ください',
  'booking.feeltheupgrade': 'アップグレードをご希望ですか',
  'booking.travelinstylewithextralegroom':
    'メインキャビンを選んで、足元のスペース、優先搭乗、セキュリティなどを備えたスタイリッシュな旅行をお楽しみください。それを生きて、ずっと上へ。',
  'booking.takethefasttrack': 'ファーストトラックを利用しましょう',
  'booking.breezethroughsecuritylikeyouowntheplace':
    'TSAPre✓™の迅速なスクリーニングで、まるで自宅にいるようなセキュリティをお楽しみください。メリットを享受する方法をご覧ください。',
  'booking.corporaterewards': '企業の報酬',
  'booking.abetterflighttoyournextmeetingdoesn’thavetobeanextravagance':
    '次の会議へのより良いフライトは、贅沢である必要はありません、 Elevate,Inc.は、旅行費用に対してビジネスに少しだけ利益をもたらす企業報酬プログラムです',
  'booking.packyourpoints': 'ポイントを集めましょう',
  'booking.livelargeat35,000feet':
    '35,000フィート上空をエンジョイ、Elevateに加入して、有効期限のないポイント、特典、特典フライトを集めましょう',
  'booking.allpassengerprice': '全乗客の合計金額',
  'booking.baggages': '荷物',
  'booking.orderdate': '申込日',
  'booking.passengername': '名前',
  'booking.cancelticket': 'チケットのキャンセル',
  'booking.operatedairline': '運航航空会社',
  'booking.count': '数量',
  'booking.departureflighttime': '出発時間',
  'booking.returnflighttime': '復路の出発時間',
  'booking.returnstopcount': '復路のストップ数',
  'booking.pc': '個数',
  'booking.kg': 'Kg',
  'booking.cabin': 'クラス',
  'booking.layoverairports': '乗り継ぎ空港',
  'booking.includeairports': '空港を含む',
  'booking.departduration': '往路の所要時間',
  'booking.returnduration': '復路の所要時間',
  'booking.nightcount': '泊数',
  'booking.nights': '泊',
  'booking.showflightdetail': 'フライトの詳細',
  'booking.toman': 'イラントマン',
  'booking.free': '無料',
  'booking.hour': '時間',
  'booking.minutes': '分',
  'booking.and': 'と',
  'booking.nobaggage': '荷物なし',
  'booking.mainterminal': '中央ターミナル',
  'booking.shamsi': 'イラン暦',
  'booking.miladi': '西暦',
  'booking.adultageerror': '12歳以上は大人',
  'booking.childageerror': '子どもは2歳から12歳まで',
  'booking.infantageerror': '幼児は2歳未満',
  'booking.passenger': '乗客',
  'booking.important': '重要！',
  'booking.identifynote':
    '姓名は、旅券に記載されたとおりに英語で記入してください',
  'booking.validpassportdate': '旅券の有効期限が6か月以上あること',
  'booking.adt': '大人',
  'booking.chd': '子ども',
  'booking.inf': '幼児',
  'booking.departure': '往路',
  'booking.return': '復路',
  'booking.allflightinformation': 'すべてのフライト情報',
  'booking.notavailable': '該当なし',
  'booking.previousemonth': '前月',
  'booking.nextmonth': '翌月',
  'booking.passportexpiredate': '旅券の有効期限',
  'booking.arrivein': 'に到着',
  'booking.nextdays': '翌日',
  'booking.clearallfilter': 'フィルターの解除',
  'booking.duplicatepassenger': 'ID番号または旅券番号が重複しています',
  'booking.policy': '読んだあと、同意する場合はここにチェックを入れてください',
  'booking.changecontact': 'チケット情報の送り先：',
  'booking.customeragreement': '顧客契約',
  'booking.flightrules': 'フライト規約',
  'booking.changecontacttitle': 'コンタクト情報の変更',
  'booking.fullname': '姓名',
  'booking.address': '住所',
  'booking.change': '変更',
  'booking.firstname': '名',
  'booking.lastname': '姓',
  'booking.departureairport': '出発地',
  'booking.arrivalairport': '到着地',
  'booking.previousedays': '前日',
  'booking.day': '日',
  'booking.month': '月',
  'booking.year': '年',
  'booking.changepassenger': '乗客数の変更',
  'booking.editdepartcity': '出発地を編集',
  'booking.editdestinationcity': '目的地を編集',
  'booking.editdepartdate': '出発日を編集',
  'booking.editdestinationdate': '帰国日を編集',
  'booking.changepassengernotify':
    'ここで乗客を変更すると、フライトの検索に戻ります',
  'booking.edittooltip':
    'フライト情報を変更するには、目的の項目をクリックしてください',
  'booking.books': '予約',
  'booking.reserves': '予約',
  'booking.of': 'の',
  'booking.canceled': 'キャンセル',
  'booking.history': '履歴',
  'booking.searchpassengerinfo':
    '姓名、旅券番号、ID番号、オーダー番号、チケット番号、PNR',
  'booking.issued': '発行',
  'booking.bought': '発行',
  'booking.serviceType': 'サービスタイプ',
  'booking.serviceName': 'フライト、ホテル、列車…',
  'booking.invoicenumber': 'オーダー番号',
  'booking.chooseticket': 'どのチケットをキャンセルしますか？',
  'booking.cancelreturn': '復路チケットのみキャンセルします',
  'booking.cancelroundtrip': '全チケットをキャンセルします',
  'booking.addflight': 'フライトを追加してください',
  'booking.showmulticity': 'すべてのフライトを表示してください',
  'booking.view': '表示',
  'booking.takeofffrom': 'からの出発時間',
  'booking.at': 'に　',
  'booking.tripsi': 'トリプシー',
  'booking.includetax': '価格には税金およびエアライン費用が含まれています',
  'booking.paymentsummery': '支払い概要',
  'booking.counter': 'カウンター',
  'booking.sum': '合計価格',
  'booking.transaction': '取引明細',
  'booking.countercommission': 'カウンター手数料レポート',
  'booking.domesticflightscount': '国内線数',
  'booking.internationalflightscount': '国際線数',
  'booking.createdate': '日付を作成してください',
  'booking.income': '所得',
  'booking.notwithdrawincome': '引き出されていない所得',
  'booking.notwithdrawpoint': '引き出されていないポイント',
  'booking.withdrableincome': '引き出し可能な所得',
  'booking.withdrablepoint': '引き出し可能なポイント',
  'booking.pendingincome': '一時停止中の所得',
  'booking.pendingpoint': '一時停止中のポイント',
  'booking.collectedpoint': '獲得ポイント',
  'booking.spentpoint': '利用したポイント',
  'booking.paymentstatus': '支払い状況',
  'booking.withdrawdate': '引き落とし日',
  'booking.countername': 'カウンター名',
  'booking.canceleditting': 'キャンセル',
  'booking.nationalcode': 'ID番号',
  'booking.previousweek': '前週',
  'booking.nextweek': '次週',
  'booking.allprice': '価格はすべてイラントマンです',
  'booking.allpriceisrial': 'すべての価格はIRRで表示されています',
  'booking.showallcalendar': 'マトリックス価格を表示',
  'booking.hideallcalendar': 'マトリックス価格を閉じる',
  'booking.multicitytrip': '複数都市の旅',
  'booking.selectstakeholder': '利害関係者を選択してください',
  'booking.changestakeholder': '利害関係者を変更してください',
  'booking.ticketwithoutprice': '価格なしのチケット',
  'booking.markupticket': 'マークアップ込みチケット',
  'booking.orginalticket': 'オリジナルチケット',
  'booking.markup': 'マークアップ',
  'booking.removeflight': 'フライトを削除してください',
  'booking.continueguest': 'ゲストとして継続',
  'booking.hotel': 'ホテル',
  'booking.trackorder': 'オーダーの追跡',
  'booking.trackingcode': '追跡コード',
  'booking.searchyourorders': 'オーダーを検索してください',
  'booking.panel': 'パネル',
  'booking.required': '必須',
  'booking.baggagerules': '預かり荷物規約',
  'booking.userpoint': 'デリック賞',
  'booking.notresult': '追跡コードが無効です',
  'booking.attachpassport': '旅券のアップロード',
  'booking.payhint': '続行するには、顧客契約とフライト規約を確認してください',
  'booking.completecontactdescription':
    'チケットを発行した人の連絡先情報をすべて入力してください。',
  'booking.updatepassenger': '乗客情報をアップデートしてください',
  'booking.paylater': '後払い',
  'booking.pnr': 'PNR',
  'booking.penaltyprice': 'ペナルティー金額',
  'booking.sumcancelprice': '返金可能金額の合計',
  'booking.paymenttype': '支払い形式',
  'booking.chargecredit': 'クレジットをチャージしてください',
  'booking.chargecreditinfo':
    '料金は、最大7営業日でドンヤロのクレジットから引き落とされます',
  'booking.deposit': '銀行カードに入金',
  'booking.depositinfo':
    '料金は、購入に利用した銀行口座から最大7営業日で引き落とされます',
  'booking.cancelmessage':
    'キャンセルリクエストを受け付けました、現在手続き中です',
  'booking.contactus':
    '問題が発生した場合は、ドンヤロのサポートチームに連絡してください',
  'booking.sendproblem': '問題を送信してください',
  'booking.downloadticket': 'チケットのダウンロード',
  'booking.notrefundable': '返金できません',
  'booking.sendrequest': 'リクエストを送信してください',
  'booking.withdrawtype': '引き落としの形式',
  'booking.hours': '時間',
  'booking.before': '出発前',
  'booking.flight': 'フライト',
  'booking.exacttime': '正午',
  'booking.until': 'まで',
  'booking.afterflight': '出発後',
  'booking.beforeflight': '出発前',
  'booking.after': 'の後',
  'booking.fromhours': 'から',
  'booking.agenycommission': '代理店のコミッション',
  'booking.unknown': '不明',
  'booking.callsupport':
    'チケット発行の際にエラーが発生しました、サポートに連絡してください',
  'booking.searchtimeout': 'このフライトをもう一度検索しますか？',
  'booking.timeout': '検索時間...',
  'booking.searchagaininfo': 'これを探す時間」',
  'booking.searchagaininfomsg': 'フライトが終了しました',
  'booking.searchagian': 'このフライトを再度検索してください',
  'booking.startagain': '別のフライトを検索してください',
  'booking.nocancelrules': 'フライト規約が見つかりません',
  'booking.andhigher': '以上',
  'booking.printticket': 'チケットの印刷',
  'booking.retrivedocument': 'ドキュメントの入手',
  'booking.forthepassenger': '乗客用',
  'booking.flightticket': '航空券',
  'booking.ticketno': 'チケット番号',
  'booking.deptime': '出発時間',
  'booking.cancelterm':
    '1-チャーター便のキャンセル条件は、プロバイダーの規則によって異なります。キャンセルされない可能性があります',
  'booking.cancelrulehint':
    '2-キャンセル料金は航空会社の規則によって異なります',
  'booking.attention': '注意：出発の2時間前までに空港にお越しください',
  'booking.valididentify':
    '3-IDカード、出生証明書、旅券などの有効な身分証明書をご持参ください。',
  'booking.online': 'オンライン',
  'booking.selectcountry': '国名を選択',
  'booking.calendar': 'カレンダー',
  'booking.countercommissionreport': 'カウンター手数料レポート',
  'booking.hasusername': 'ユーザー名をお持ちですか？',
  'booking.nousername': 'ユーザー名をお持ちではないですか？',
  'booking.signuporguest': '（新規登録またはゲストユーザー）',
  'booking.guestuser': 'ゲストユーザー',
  'booking.notuserbefore': '今すぐ登録してポイントを獲得',
  'booking.reservationfail': 'このフライトの予約はできません',
  'booking.reservation': 'このフライトでは一時的な予約が可能です',
  'booking.reservationerror': '予約できませんでした！',
  'booking.passengererror': '乗客情報にエラーがあります！',
  'booking.passengerInformationHint': '乗客情報を確認してください',
  'booking.displayticket': 'チケットの表示法方法',
  'booking.selectcustomer': '顧客を選択してください',
  'booking.asacustomer': '顧客の決定',
  'booking.changeticketprice': 'チケット料金表示の変更',
  'booking.save': '保存',
  'booking.fromwallet': 'ウォレット',
  'booking.fromcredit': 'クレジット',
  'booking.frompoint': 'ポイント',
  'booking.usederik': 'デリックでチケットの支払い',
  'booking.yourderik': 'あなたのデリック',
  'booking.equivalentprice': '相当価格：',
  'booking.bookinginvoiceno': '予約インボイス番号',
  'booking.importpnr': 'PNRをインポートしてください',
  'booking.pnrhint': 'システムを選択してください',
  'booking.pnrsteps': 'PNRを利用の際は、次のステップを踏んでください',
  'booking.enteryour': '1- Enter to your Amadeus panel',
  'booking.openreference': '2- Make your reservation in Amadeus panel. ',
  'booking.pnr3': '3- Enter the passenger passport information completely. ',
  'booking.entercommand':
    '4-Enter the following command code and then press enter key. ',
  'booking.savepnr': '5-Save your PNR and press enter key. ',
  'booking.pnr6':
    '6- In Tripsi page, enter your PNR number in the reference number section. ',
  'booking.pnr7': '7- In the Passenger Last Name field, enter it. ',
  'booking.pnr8': '8- Click the booking button. ',
  'booking.pnr9': '9- Go to the payment page after checking the information. ',
  'booking.pnr10': '10- Your ticket has been issued. ',

  'booking.laststep':
    'これで下のボックスにリファレンスが入力でき、エクスポート手順が実行できます',
  'booking.leadlastname': '主な乗客の姓',
  'booking.usepnr': 'PNRをインポートして表示',
  'booking.buyer': '購入者',
  'booking.pnrnotfound': '項目が見つかりませんでした',
  'booking.uploadpassporterror': '旅券情報が判読できません',
  'booking.servererror': 'サーバーに問題があります',
  'booking.accessdenied': 'アクセス拒否',
  'booking.newpassenger': '新しい乗客を追加してください',
  'booking.errormorepassenger': '乗客数が多すぎます',
  'booking.passengertypeerror': '乗客のタイプが無効です',
  'booking.chooseallpassenger': 'すべての乗客を選んでください',
  'booking.checkpassport':
    '旅券データをアップロード後、あなたの情報を確認してください',
  'booking.apply': '適用する',
  'booking.flightinformation': 'フライト情報',
  'booking.adultticketprice': '大人チケット',
  'booking.childticketprice': '子どもチケット',
  'booking.infantticketprice': '幼児チケット',
  'booking.airplane': '航空機',
  'booking.time': '時間',
  'booking.invoiceno': 'インボイス番号',
  'booking.charter': 'チャーター',
  'booking.systemic': 'システムの',
  'booking.type': 'タイプ',
  'booking.paymentprice': '支払価格',
  'booking.pnrcode': 'PNR',
  'booking.selectpayment': '支払い方法を選択してください',
  'booking.temporaryreservation': '予約',
  'booking.direction': 'ルート',
  'booking.passengercount': '乗客数',
  'booking.reservesuccess': 'チケットは一時的に予約されています',
  'booking.passengertotalprice': '乗客の合計金額',
  'booking.stopduration': 'ストップ時間',
  'booking.invalidbirthdate': '生年月日が無効です',
  'booking.invalidexpireday': '旅券の有効期限が無効です',
  'booking.fullbirthdate': '生年月日を選択してください',
  'booking.fullexpiredate': '旅券の有効期限を選択してください',
  'booking.creditpayment': 'クレジットによる支払いが完了しました',
  'booking.walletpatment': 'ウォレットによる支払いが完了しました',
  'booking.pointpayment': 'ポイントによる支払いが完了しました',
  'booking.tickettimelimit': 'チケットの期限',
  'booking.onbehalf': 'に代わり',
  'booking.expirereserve': '期限切れ',
  'booking.person': '人',
  'booking.startorderdate': 'オーダー開始日',
  'booking.endorderdate': 'オーダー終了日',
  'booking.missflight': 'フライトに乗り遅れる',
  'booking.multiairline': '複数の航空会社',
  'booking.in': 'に',
  'booking.afterdiscount': 'ディスカウントの後',
  'booking.editissuer': 'チケットを発行した人の連絡先情報の編集',
  'booking.referencenumber': 'リファレンス',
  'booking.train': '列車',
  'booking.bus': 'バス',
  'booking.economy': 'エコノミークラス',
  'booking.business': 'ビジネスクラス',
  'booking.first': 'もみ',
  'booking.allcabinclasses':
    '選択したルートのすべてのフライトクラスが表示されます。',
  'booking.findtrip': '旅を探す',
  'booking.selectacity': '都市を選択',
  'booking.destinations': '目的地',
  'booking.london': 'ロンドン',
  'booking.rome': 'ローマ',
  'booking.istanbul': 'イスタンブール',
  'booking.deletePassengerTitle': '乗客の削除',
  'booking.invalidnationalcode': '無効なID番号',
  'booking.showgatewayerror': 'ゲートウェイエラーを表示',
  'booking.alternativefrom': 'から',
  'booking.alternativeto': 'に',
  'booking.commingsoon': 'まもなく公開　',
  'booking.searchorigin': '出発地の検索',
  'booking.searchdestination': '目的地の検索',
  'booking.plannedflight': '予定フライト',
  'booking.yesterday': '昨日',
  'booking.twodaysago': '2日前',
  'booking.englishname': '名（英語）',
  'booking.englishlastname': '姓（英語',
  'booking.rialtotalprice': '合計価格（リアル',
  'booking.gotosearchflight': '検索フライトに移動',
  'booking.seat': 'シート',
  'booking.englishticket': '英語版のチケット',
  'booking.persianticket': 'ペルシア語版のチケット',
  'booking.searchmypassenger': '前の乗客から検索',
  'booking.selectairporterror': '上から出発地と目的地を選択',
  'booking.providergateway': 'プロバイダーゲートウェイ',
  'booking.seniorageerror': '高齢者の年齢は60歳以上である必要があります',
  'booking.toddlerageerror': 'toodlerの年齢は2歳未満である必要があります',
  'booking.noresultwithfilter':
    '選択したフィルターで結果が見つかりません。変更してください',
  'booking.expirereservation': '期限切れの予約',
  'booking.unpaidreservation': '未払いの予約',
  'booking.selectbooking': '有料のチケットを選択してください',
  'booking.mobileformaterror': 'モバイルフォーマットが無効です',
  'booking.poweredby': 'Powered by',
  'booking.hoteldescription': '30％割引で今すぐホテルを予約',
  'booking.tourdescription':
    'ノウルーズ1401の21日間のヨーロッパツアー。12月末までの登録5％割引',
  'booking.parishotel': 'Paris ホテル',
  'booking.poweredby': 'チケット :',
  'booking.stopdurationin': '停止期間',
  'booking.contactInfo': '連絡先情報の発行',
  'booking.expireDate': '有効期限',
  'booking.pnrdesc': 'アマデウスで予約し、ここで発行してください。',
  'booking.officeid': 'オフィスID',
  'booking.pnrhelp': 'ユーザーマニュアル',
  'booking.ticketinfo': 'チケットの詳細',
  'booking.saletotalamount': '販売総額',
  'booking.emailticket': 'メールチケット',
  'booking.changeticketprice': '価格の変更',
  'booking.backpreviouspage': '前のページに戻る',
  'booking.changecabinclass': 'キャビンクラスの変更',
  'booking.changecabinclassnotify':
    'このステップでキャビンクラスを変更すると、フライトステップの検索に戻ります!!!!',
  'booking.ticketprice': 'チケットの金額',
  'booking.payableamount': '支払額',
  'booking.showflight': 'フライトを表示',
  'booking.tripdirection': '旅行の方向',
  'booking.selectpaymenttype': '支払いタイプの選択',
  'booking.title': '題名',
  'booking.yourchoice': 'あなたの選択',
  'booking.mr': 'Mr。',
  'booking.mrs': 'Mrs。',
  'booking.result': '結果',
  'booking.changeflight': 'フライトルートの変更',
  'booking.arrivetime': '到着時間',
  'booking.sortbyarrivetime': '到着時間順',
  'booking.sortbyduration': '期間で並べ替え',
  'booking.sortbypoint': 'ポイントで並べ替え',
  'booking.tickettype': 'チケットの種類',
  'booking.selectall': 'すべて選択',
  'booking.addpassenger': '乗客を追加',
  'booking.textpassenger':
    '下記のフォームよりお客様の情報を入力し、最後に情報を登録してください。',
  'booking.showavailableflight': '利用可能なフライトを表示',
  'booking.roomtype': '部屋タイプ',
  'booking.extrabed': 'エキストラベッド',
  'booking.numberofrooms': '室数',
  'booking.addnewroom': '新しい部屋を追加する',
  'booking.picturesofroom': '部屋の写真',
  'booking.availsflight': '空席のあるフライト',
  'booking.events': 'カレンダーイベント',
  'booking.eventsinfo': '選択した各国のイベントを表示',
  'booking.want': 'したいです',
  'booking.setmaxprice': '最高価格を設定する',
  'booking.selectcity': '最初に出発地と目的地の空港を選択してください',
  'booking.allcabinselected':
    '国内線では、すべてのフライトクラスが検索されます',
  'booking.all': '全て',
  'booking.passportImage': 'パスポートの画像',
  'booking.passporthint':
    '700*500のサイズで、サンプル通り鮮明な画像をアップロードしてください。',
  'booking.showsample': 'パスポートのサンプルを表示',
  'booking.reservebefore': 'このフライトを事前に予約する',
  'booking.editpassengersinfo': '乗客情報の編集',
};
